import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CustomDatePicker = ({ workDate, handleDateChange, isValidDate, SpecificDayCopy }) => {
    const [startDate, setStartDate] = useState(workDate);
    const [view, setView] = useState("date");
    const [isChangingMonth, setIsChangingMonth] = useState(false);

    useEffect(() => {
        setStartDate(workDate);
    }, [workDate]);

    const renderCustomHeader = ({
        date,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
    }) => {
        return (
            <div style={{ 
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center", 
                padding: "10px", 
                backgroundColor: "#f0f0f0", 
                borderBottom: "1px solid #ccc" 
            }}>
                <button 
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsChangingMonth(true);
                        decreaseMonth();
                    }}
                    disabled={prevMonthButtonDisabled}
                    style={{ 
                        background: "none", 
                        border: "none", 
                        fontSize: "16px", 
                        cursor: "pointer",
                        color: prevMonthButtonDisabled ? "#ccc" : "#333",
                    }}
                >
                    {"<"}
                </button>
                <div style={{ display: "flex", gap: "10px" }}>
                    <span
                        onClick={(e) => {
                            e.stopPropagation();
                            setView(view === "month" ? "date" : "month");
                        }}
                        style={{ 
                            cursor: "pointer", 
                            fontWeight: "bold", 
                            fontSize: "16px",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            backgroundColor: view === "month" ? "#e0e0e0" : "transparent"
                        }}
                    >
                        {date.toLocaleString("en-US", { month: "long" })}
                    </span>
                    <span
                        onClick={(e) => {
                            e.stopPropagation();
                            setView(view === "year" ? "date" : "year");
                        }}
                        style={{ 
                            cursor: "pointer", 
                            fontWeight: "bold", 
                            fontSize: "16px",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            backgroundColor: view === "year" ? "#e0e0e0" : "transparent"
                        }}
                    >
                        {date.getFullYear()}
                    </span>
                </div>
                <button 
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsChangingMonth(true);
                        increaseMonth();
                    }}
                    disabled={nextMonthButtonDisabled}
                    style={{ 
                        background: "none", 
                        border: "none", 
                        fontSize: "16px", 
                        cursor: "pointer",
                        color: nextMonthButtonDisabled ? "#ccc" : "#333"
                    }}
                >
                    {">"}
                </button>
            </div>
        );
    };

    return (
        <DatePicker
            selected={isValidDate(startDate) ? startDate : null}
            onChange={(date) => {
                if (date && isValidDate(date)) {
                    setStartDate(date);
                    if (!isChangingMonth) {
                        handleDateChange(date);
                        if (SpecificDayCopy) {
                            SpecificDayCopy(date);
                        }
                        if (view !== "date") {
                            setView("date");
                        }
                    }
                }
            }}
            inline
            renderCustomHeader={renderCustomHeader}
            showMonthYearPicker={view === "month"}
            showYearPicker={view === "year"}
            dateFormat="MMMM yyyy"
            calendarClassName="custom-datepicker"
            onMonthChange={(date) => {
                setIsChangingMonth(false);
                if (view === "date") {
                    const fallbackDate = new Date(); // Fallback to the current date
                    const validStartDate = startDate instanceof Date && !isNaN(startDate) ? startDate : fallbackDate;
                    const newDate = new Date(date.getFullYear(), date.getMonth(), validStartDate.getDate());
                    if (isValidDate(newDate)) {
                        setStartDate(newDate);
                    }
                }
            }}
            onSelect={(date) => {
                if (date && isValidDate(date)) {
                    setStartDate(date);
                    handleDateChange(date);
                    if (SpecificDayCopy) {
                        SpecificDayCopy(date);
                    }
                    setView("date");
                }
            }}
        />
    );
};

export default CustomDatePicker;
